import { CLIENT_STATUS, CLIENT_STATUS_SUCCESS, CLIENT_STATUS_FAIL } from "./actionType";

export const getClientStatus = (checked, isGetid, history) => (
    {
        type: CLIENT_STATUS,
        payload: { checked, isGetid, history },
    })
export const getClientStatusSuccess = (isGetid) => ({
    type: CLIENT_STATUS_SUCCESS,
    payload: isGetid
})
export const getClientStatusFail = error => ({
    type: CLIENT_STATUS_FAIL,
    payload: error
})